(function () {
  if (window.CDCleerHomeDisinfectDry) return;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function smoothstep(value) {
    var t = clamp(value, 0, 1);
    return t * t * (3 - 2 * t);
  }

  function getLineflowRole(node) {
    if (!node) return 'support';
    if (node.closest('.cd-hdd__title--top')) return 'top';
    if (node.closest('.cd-hdd__title--bottom')) return 'bottom';
    if (node.closest('.cd-hdd__side-title')) return 'support-title';
    return 'support';
  }

  function splitLineflowNode(node) {
    if (!node) return null;

    var original = node.getAttribute('data-cd-hdd-original');
    if (!original) {
      original = node.textContent || '';
      node.setAttribute('data-cd-hdd-original', original);
    }

    if (!node.getAttribute('data-cd-hdd-lineflow-ready')) {
      var fragment = document.createDocumentFragment();

      Array.prototype.forEach.call(original, function (char, index) {
        var span = document.createElement('span');
        var isSpace = /\s/.test(char);

        span.className = 'cd-hdd-line__char' + (isSpace ? ' cd-hdd-line__char--space' : '');
        span.setAttribute('aria-hidden', 'true');
        span.style.setProperty('--cd-hdd-char-index', index);
        span.style.setProperty('--cd-hdd-char-progress', '0');
        span.textContent = isSpace ? '\u00A0' : char;
        fragment.appendChild(span);
      });

      node.textContent = '';
      node.appendChild(fragment);
      node.setAttribute('aria-label', original);
      node.setAttribute('data-cd-hdd-lineflow-ready', 'true');
    }

    return {
      node: node,
      role: getLineflowRole(node),
      chars: Array.prototype.slice.call(node.querySelectorAll('.cd-hdd-line__char'))
    };
  }

  function prepareLineflows(section) {
    return Array.prototype.slice
      .call(section.querySelectorAll('[data-cd-hdd-lineflow]'))
      .map(splitLineflowNode)
      .filter(Boolean);
  }

  function setLineflowProgress(flows, role, progress) {
    if (!flows || !flows.length) return;

    flows.forEach(function (flow) {
      if (!flow || flow.role !== role || !flow.chars.length) return;

      var count = Math.max(flow.chars.length - 1, 1);
      var spread = flow.chars.length > 12 ? 0.34 : 0.24;
      var usable = Math.max(1 - spread, 0.001);

      flow.chars.forEach(function (char, index) {
        var delay = (index / count) * spread;
        var local = smoothstep(clamp((progress - delay) / usable, 0, 1));
        char.style.setProperty('--cd-hdd-char-progress', local.toFixed(4));
      });
    });
  }

  function pxVar(element, name) {
    var value = getComputedStyle(element).getPropertyValue(name).trim();
    if (!value) return 0;
    if (
      value.indexOf('calc(') === 0 ||
      value.indexOf('min(') === 0 ||
      value.indexOf('max(') === 0 ||
      value.indexOf('clamp(') === 0
    ) {
      return 0;
    }
    return parseFloat(value) || 0;
  }

  function setVar(element, name, value) {
    element.style.setProperty(name, value);
  }

  function forceHeaderLight(shouldLight) {
    var root = document.documentElement;
    var header = document.querySelector('[data-cd-hero-header]');
    var isPdpSurfaceDriven =
      root.classList.contains('cd-pdp-surface-ready') &&
      document.querySelector('[data-cd-pdp-surface-start]');
    var isHomeSurfaceDriven =
      root.classList.contains('cd-home-surface-ready') &&
      document.querySelector('[data-cd-surface-start]');
    var isGlobalSurfaceDriven =
      root.classList.contains('cd-global-surface-ready') &&
      document.querySelector('[data-cd-global-surface-start], [data-cd-global-surface], [data-cd-surface-color]');

    if (isPdpSurfaceDriven || isHomeSurfaceDriven || isGlobalSurfaceDriven) {
      root.classList.remove('cd-hdd-force-header-light');
      if (window.CDCleerPdpSurfaceBlend && typeof window.CDCleerPdpSurfaceBlend.update === 'function') {
        window.CDCleerPdpSurfaceBlend.update();
      }
      if (window.CDCleerSurfaceBlend && typeof window.CDCleerSurfaceBlend.update === 'function') {
        window.CDCleerSurfaceBlend.update();
      }
      if (window.CDCleerGlobalAnimations && typeof window.CDCleerGlobalAnimations.update === 'function') {
        window.CDCleerGlobalAnimations.update();
      }
      return;
    }

    root.classList.toggle('cd-hdd-force-header-light', !!shouldLight);

    if (header) {
      header.classList.toggle('is-scheme-light', !!shouldLight);
      header.classList.toggle('is-scheme-dark', !shouldLight);
    }

    if (!shouldLight && window.CDCleerHeaderTheme && typeof window.CDCleerHeaderTheme.refresh === 'function') {
      window.CDCleerHeaderTheme.refresh();
    }
  }

  function initSection(section) {
    if (!section || section.dataset.cdHddReady === 'true') return null;

    var stage = section.querySelector('[data-cd-hdd-stage]');
    var sticky = section.querySelector('[data-cd-hdd-sticky]');
    var media = section.querySelector('[data-cd-hdd-media]');
    var fixedMedia = section.querySelector('[data-cd-hdd-fixed-media]');

    if (!stage || !sticky || !media || !fixedMedia) return null;

    section.dataset.cdHddReady = 'true';

    var state = {
      section: section,
      stage: stage,
      sticky: sticky,
      media: media,
      fixedMedia: fixedMedia,
      lineflows: prepareLineflows(section),
      raf: 0,
      metrics: null,
      isHeaderLight: false,
      isPinned: false,
      isExiting: false,
      isPrePinning: false,
      isHandoffActive: false
    };

    function measure() {
      var viewportH = window.innerHeight || document.documentElement.clientHeight || 0;
      var stageHeight = stage.offsetHeight || 1;
      var mediaH = pxVar(section, '--cd-hdd-pin-image-h') || media.offsetHeight || fixedMedia.offsetHeight || 1;
      var isMobile = window.matchMedia('(max-width: 1024px)').matches;

      state.metrics = {
        viewportH: viewportH,
        viewportCenter: viewportH * 0.5,
        stageHeight: stageHeight,
        stickyRange: Math.max(stageHeight - viewportH, 1),
        mediaH: mediaH,
        mediaSettleDistance: isMobile ? 10 : 14,
        // Keep the fixed product image out of the preceding carousel. It now
        // begins entering only after this section occupies most of the screen.
        fixedEnterStart: viewportH * (isMobile ? 0.38 : 0.56),
        fixedCenterBy: viewportH * (isMobile ? 0.08 : 0.18),
        fixedStartOffset: viewportH * (isMobile ? 0.26 : 0.3),
        fixedFadeDistance: viewportH * (isMobile ? 0.1 : 0.08),
        handoffStartPx: isMobile ? 24 : 32,
        handoffEndPx: isMobile ? -80 : -96,
        titleTravel: isMobile ? 30 : 38,
        sideTravel: isMobile ? 28 : 44
      };
    }

    function update() {
      state.raf = 0;

      if (!state.metrics) {
        measure();
      }

      var metrics = state.metrics;
      var stageRect = state.stage.getBoundingClientRect();
      var sectionRect = state.section.getBoundingClientRect();
      var header = document.querySelector('[data-cd-hero-header]');
      var headerBottom = header ? header.getBoundingClientRect().bottom : 0;

      var fixedTravel = Math.max(metrics.fixedEnterStart - metrics.fixedCenterBy, 1);
      var fixedSettleRaw = clamp((metrics.fixedEnterStart - stageRect.top) / fixedTravel, 0, 1);
      var fixedSettle = smoothstep(fixedSettleRaw);

      var fixedFadeRaw = clamp((metrics.fixedEnterStart - stageRect.top) / Math.max(metrics.fixedFadeDistance, 1), 0, 1);
      var fixedFadeIn = smoothstep(fixedFadeRaw);

      var shouldPrePin = stageRect.top <= metrics.fixedEnterStart && stageRect.top > 0 && stageRect.bottom > metrics.viewportCenter;

      var pinRaw = clamp((-stageRect.top) / metrics.stickyRange, 0, 1);
      var pin = smoothstep(pinRaw);
      var entry = Math.max(fixedSettle, pin);

      var handoffRaw = clamp(
        (metrics.handoffStartPx - stageRect.top) / (metrics.handoffStartPx - metrics.handoffEndPx),
        0,
        1
      );
      var handoffBlend = smoothstep(handoffRaw);
      var isHandoffActive = handoffBlend > 0 && handoffBlend < 1;

      var textRaw = clamp((pinRaw - 0.05) / 0.18, 0, 1);
      var textIn = smoothstep(textRaw);

      var bottomTextRaw = clamp((pinRaw - 0.1) / 0.2, 0, 1);
      var bottomTextIn = smoothstep(bottomTextRaw);

      var exitRaw = clamp((pinRaw - 0.86) / 0.14, 0, 1);
      var exit = smoothstep(exitRaw);

      var mediaScale = 0.965 + entry * 0.035;
      var mediaY = (1 - pin) * metrics.mediaSettleDistance - exit * 8;
      var fixedY = (1 - fixedSettle) * metrics.fixedStartOffset;
      var fixedScale = 0.965 + fixedSettle * 0.035;
      var stackY = -exit * 16;

      var mediaOpacity = handoffBlend;
      var fixedOpacity = fixedFadeIn * (1 - handoffBlend);

      var mediaCenterX = 0;
      var mediaCenterY = 0;
      var fixedCenterX = 0;
      var fixedCenterY = 0;
      var mediaOffsetX = 0;
      var mediaOffsetY = 0;

      if (handoffBlend > 0 && handoffBlend < 1) {
        var mediaRect = state.media.getBoundingClientRect();
        var fixedRect = state.fixedMedia.getBoundingClientRect();

        mediaCenterX = mediaRect.left + mediaRect.width * 0.5;
        mediaCenterY = mediaRect.top + mediaRect.height * 0.5;
        fixedCenterX = fixedRect.left + fixedRect.width * 0.5;
        fixedCenterY = fixedRect.top + fixedRect.height * 0.5;

        mediaOffsetX = (fixedCenterX - mediaCenterX) * (1 - handoffBlend);
        mediaOffsetY = (fixedCenterY - mediaCenterY) * (1 - handoffBlend);
      }

      var topTitleY = (1 - textIn) * metrics.titleTravel;
      var bottomTitleY = -(1 - bottomTextIn) * metrics.titleTravel;
      var sideLeftY = (1 - textIn) * metrics.sideTravel;
      var sideRightY = (1 - bottomTextIn) * metrics.sideTravel;

      setVar(state.section, '--cd-hdd-media-scale', mediaScale.toFixed(4));
      setVar(state.section, '--cd-hdd-media-y', mediaY.toFixed(2) + 'px');
      setVar(state.section, '--cd-hdd-media-correct-x', mediaOffsetX.toFixed(2) + 'px');
      setVar(state.section, '--cd-hdd-media-correct-y', mediaOffsetY.toFixed(2) + 'px');
      setVar(state.section, '--cd-hdd-media-opacity', mediaOpacity.toFixed(4));
      setVar(state.section, '--cd-hdd-fixed-scale', fixedScale.toFixed(4));
      setVar(state.section, '--cd-hdd-fixed-y', fixedY.toFixed(2) + 'px');
      setVar(state.section, '--cd-hdd-fixed-opacity', fixedOpacity.toFixed(4));
      setVar(state.section, '--cd-hdd-stack-y', stackY.toFixed(2) + 'px');
      setVar(state.section, '--cd-hdd-title-top-opacity', textIn.toFixed(4));
      setVar(state.section, '--cd-hdd-title-top-y', topTitleY.toFixed(2) + 'px');
      setVar(state.section, '--cd-hdd-title-bottom-opacity', bottomTextIn.toFixed(4));
      setVar(state.section, '--cd-hdd-title-bottom-y', bottomTitleY.toFixed(2) + 'px');
      setVar(state.section, '--cd-hdd-side-opacity', textIn.toFixed(4));
      setVar(state.section, '--cd-hdd-side-left-y', sideLeftY.toFixed(2) + 'px');
      setVar(state.section, '--cd-hdd-side-right-y', sideRightY.toFixed(2) + 'px');

      setLineflowProgress(state.lineflows, 'top', textIn);
      setLineflowProgress(state.lineflows, 'bottom', bottomTextIn);
      setLineflowProgress(state.lineflows, 'support-title', Math.max(textIn, bottomTextIn));
      setLineflowProgress(state.lineflows, 'support', Math.max(textIn, bottomTextIn));

      if (shouldPrePin !== state.isPrePinning) {
        state.isPrePinning = shouldPrePin;
        state.section.classList.toggle('is-pre-pinning', shouldPrePin);
      }

      if (isHandoffActive !== state.isHandoffActive) {
        state.isHandoffActive = isHandoffActive;
        state.section.classList.toggle('is-handoff-active', isHandoffActive);
      }

      var shouldPin = stageRect.top <= 0 && stageRect.bottom > metrics.viewportH;
      if (shouldPin !== state.isPinned) {
        state.isPinned = shouldPin;
        state.section.classList.toggle('is-image-pinned', shouldPin);
      }

      var shouldExit = pinRaw > 0.86;
      if (shouldExit !== state.isExiting) {
        state.isExiting = shouldExit;
        state.section.classList.toggle('is-image-exiting', shouldExit);
      }

      var shouldLightHeader = sectionRect.top <= headerBottom && sectionRect.bottom > headerBottom;
      if (shouldLightHeader !== state.isHeaderLight) {
        state.isHeaderLight = shouldLightHeader;
        forceHeaderLight(shouldLightHeader);
      }

      if (window.CDCleerPdpSurfaceBlend && typeof window.CDCleerPdpSurfaceBlend.update === 'function') {
        window.CDCleerPdpSurfaceBlend.update();
      }
      if (window.CDCleerSurfaceBlend && typeof window.CDCleerSurfaceBlend.update === 'function') {
        window.CDCleerSurfaceBlend.update();
      }
      if (window.CDCleerGlobalAnimations && typeof window.CDCleerGlobalAnimations.update === 'function') {
        window.CDCleerGlobalAnimations.update();
      }
    }

    function requestUpdate() {
      if (!state.raf) {
        state.raf = window.requestAnimationFrame(update);
      }
    }

    function onResize() {
      state.metrics = null;
      requestUpdate();
    }

    state.requestUpdate = requestUpdate;
    state.onResize = onResize;

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);

    if (window.ResizeObserver) {
      state.resizeObserver = new ResizeObserver(onResize);
      state.resizeObserver.observe(section);
      state.resizeObserver.observe(stage);
      state.resizeObserver.observe(media);
      state.resizeObserver.observe(fixedMedia);
    }

    requestUpdate();
    setTimeout(requestUpdate, 60);
    setTimeout(requestUpdate, 180);
  
    return state;
  }

  var instances = [];

  function mountAll() {
    document.querySelectorAll('[data-cd-hdd]').forEach(function (section) {
      var instance = initSection(section);
      if (instance) instances.push(instance);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var section = event.target.querySelector('[data-cd-hdd]') || (event.target.matches && event.target.matches('[data-cd-hdd]') ? event.target : null);
    if (!section) return;
    var instance = initSection(section);
    if (instance) instances.push(instance);
  });

  window.CDCleerHomeDisinfectDry = {
    refresh: function () {
      instances.forEach(function (instance) {
        if (!instance) return;
        instance.metrics = null;
        if (typeof instance.requestUpdate === 'function') {
          instance.requestUpdate();
        }
      });
    },
    mount: function () {
      mountAll();
      this.refresh();
    }
  };
})();
